<template>
	<div class="customer">
		<div class="customer-left">
			<my-tree v-model="filterText" @node-click="treeClick" :treeData="treeData" :defaultProps="defaultProps" icon="icon-fangdajing" treeIcon="icon-kehu"></my-tree>
		</div>
		<div class="customer-right">
			<div class="filter-type">
				<div
					class="filter-btn filter-btn-primary"
					@click="
						fromData.dialogType = 1;
						dialog.addCustomer = true;
					"
					v-if="UserParentId"
				>
					增加
				</div>
				<div class="filter-btn filter-btn-primary" @click="$refs.passWordRefs.visible = true">支付密码</div>
				<span class="box_span">提示：为了虚拟币安全、请设置6-12位数字或字母支付密码、如遗忘密码请联系我司商务重置</span>
			</div>
			<div class="filter-table-wrap">
				<el-table :data="tableData.slice((currentPage - 1) * currentPageSize, currentPageSize * currentPage)" stripe style="width: 100%" height="calc(100% - 70px)">
					<el-table-column type="selection" width="55"> </el-table-column>
					<el-table-column type="index" width="50" label="序号"> </el-table-column>
					<el-table-column prop="userName" label="登录账号" width="180"> </el-table-column>
					<el-table-column prop="password" label="密码"> </el-table-column>
					<el-table-column prop="corpName" label="客户名称" width="180"> </el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<div class="cus_box">
								<div class="cus_btn" @click="edit(scope.row)">修改资料</div>
								<div class="cus_btn" @click="deleteUser(scope.row)">删除</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="邮箱">
						<template slot-scope="scope">
							<div class="cus_box">
								<div class="cus_btn" v-if="!scope.row.email" @click="addEmail(0, scope.row)">增加</div>
								<div class="cus_btn" v-if="scope.row.email" @click="addEmail(1, scope.row)">修改</div>
								<el-popconfirm v-if="scope.row.email" title="是否删除邮箱？" @confirm="deleteEamil(scope.row.userId)">
									<div class="cus_btn" slot="reference">删除</div>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="currentPageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="tableData.length"
				>
				</el-pagination>
			</div>
		</div>
		<el-dialog :title="fromData.dialogType == 1 ? '新增用户' : '修改用户'" :visible.sync="dialog.addCustomer" width="430px" @close="closedialog">
			<div class="input-item">
				<label>客户名称</label>
				<input v-model.trim="fromData.corpName" maxlength="15" />
			</div>
			<div class="input-item">
				<label>客户代码</label>
				<input v-model.trim="fromData.customCode" :disabled="fromData.dialogType == 1 ? false : true" maxlength="15" />
			</div>
			<div class="input-item">
				<label>登录账户</label>
				<input v-model.trim="fromData.name" maxlength="15" />
				<span class="form_warning" v-if="UserTips.user">请填写正确账号</span>
			</div>
			<div class="input-item">
				<label>登录密码</label>
				<input type="password" v-model.trim="fromData.password" />
			</div>
			<!-- <div class="input-item" v-show="fromData.dialogType === 1">
        <label>权限</label>
        <el-radio-group v-model="fromData.checkSim">
          <el-radio :label="1">客户</el-radio>
          <el-radio :label="2">监控员</el-radio>
        </el-radio-group>
      </div> -->
			<!-- <div class="input-item">
        <label>上级客户</label>
        <input />
      </div> -->
			<div class="input-item" style="height:auto;">
				<label>备注信息</label>
				<textarea autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" maxlength="70" rows="5" v-model="fromData.remark"></textarea>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="commitUser" size="small">{{ fromData.dialogType === 1 ? '确定' : '修改' }}</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="dialog.removeCustomer" width="300px" class="remove-dialog">
			<div class="removeCustomer">
				<div class="error-icon"><i class="iconfont icon-gantanhao"></i></div>
				<p class="comfir-msg">
					是否确认删除<span>（{{ fromData.corpName }}）</span>
				</p>
				<span class="tips-msg">删除成功后不可恢复</span>
				<!-- <span class="tips-msg">该客户下的SIM卡会回到您卡组</span> -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="deleteData" size="small">确认删除</el-button>
			</span>
		</el-dialog>
		<passWord ref="passWordRefs" />
		<Email ref="emailRefs" :emailvisible="emailvisible" :emailStatus="emailStatus" @closeEamil="closeEamil" />
	</div>
</template>

<script>
import myTree from '@/components/myTree/';
import { handleTree } from '@/util/handTree';
import { message } from '@/util/message';
import passWord from './password.vue';
import Email from './component/Email.vue';
export default {
	methods: {
		closeEamil() {
			this.emailvisible = false;
			this.getNextUsers(this.$store.state.LOGINUSER.id, true);
		},
		addEmail(emailStatus, row) {
			//emailStatus 0:添加 1：修改
			this.emailvisible = true;
			this.emailStatus = emailStatus;
			this.$refs.emailRefs.changeData(row);
			console.log(row);
		},
    async deleteEamil (userId) {
			const res = await this.$API.deleteUserEmail({ userId });
			if (res.code !== 0) return this.$message.error(res.msg);
			this.$message.success(res.msg);
			this.getNextUsers(this.$store.state.LOGINUSER.id, true);
		},
		//删除账号

		async deleteData() {
			const { code, msg } = await this.$API.deleteSubAccount({ userId: this.fromData.userId });
			this.$message({
				type: code === 0 ? 'success' : 'warning',
				message: code === 0 ? '删除成功' : msg,
			});
			if (code === 0) {
				this.getNextUsers(this.$store.state.LOGINUSER.id, true);
				this.dialog.removeCustomer = false;
			}
		},
		checkUser(str) {
			var re = /^[a-zA-z]\w{0,15}$/;
			if (re.test(str)) {
				return false;
			} else {
				return true;
			}
		},
		checkpsw(str) {
			if (str.length >= 6) {
				return true;
			} else {
				message(-1, '密码长度不能少于6位');
				return false;
			}
		},
		checkForm() {
			this.UserTips.user = this.checkUser(this.fromData.name);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.currentPageSize = val;
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.currentPage = val;
		},
		treeClick(data) {
			this.getNextUsers(data.userId);
		},
		// 添加用户
		async commitUser() {
			if (this.checkAll()) {
				// let a =  {corpName,name,password,remark} = this.fromData
				// this.fromData.corpName = this.fromData.corpName?this.fromData.corpName.trim():this.fromData.corpName;
				// this.fromData.name = this.fromData.name?this.fromData.name.trim():this.fromData.name;
				// this.fromData.password = this.fromData.password?this.fromData.password.trim():this.fromData.password;
				// this.fromData.remark = this.fromData.remark?this.fromData.remark.trim():this.fromData.remark;
				// this.fromData.customCode = this.fromData.customCode?this.fromData.customCode.trim():this.fromData.customCode;
				let params = {
					corpName: this.fromData.corpName,
					userName: this.fromData.name,
					password: this.fromData.password,
					remark: this.fromData.remark,
					customCode: this.fromData.customCode,
					userId: this.fromData.userId,
				};
				if (this.fromData.dialogType === 1) {
					try {
						let data = await this.$API.addUser(params);
						if (!this.treeData[0].children) {
							this.$set(this.treeData[0], 'children', []);
						}
						// this.treeData[0].children.push(data.data.user);
						// this.tableData.push(data.data.user);
						message(0, '添加成功');
						await this.getNextUsers(this.$store.state.LOGINUSER.id, true);
						this.$store.commit('GETUSERLIST', this.tableData);
						console.log(this.$store.state.userList);
					} catch (error) {
						console.error('错误信息:', error);
					}
				} else {
					let data = await this.$API.updateUser(params);
					await this.getNextUsers(this.$store.state.LOGINUSER.id, true);
					this.$store.commit('GETUSERLIST', this.tableData);
				}
			} else {
				return;
			}

			this.dialog.addCustomer = false;
		},
		checkAll() {
			if (this.fromData.corpName == '' || this.fromData.name == '' || this.fromData.password == '') {
				message(-1, '填写信息不能为空');
				return false;
			}

			if (!this.UserTips.user && this.checkpsw(this.fromData.password)) {
				return true;
			} else {
				return false;
			}
		},
		edit(data) {
			this.fromData.corpName = data.corpName;
			this.fromData.userId = data.userId;
			this.fromData.name = data.userName;
			this.fromData.password = data.password;
			this.fromData.remark = data.remark;
			this.fromData.customCode = data.customCode;
			this.fromData.dialogType = 2; // 1为增加用户  2为修改资料
			this.dialog.addCustomer = true;
			// this.fromData = data
		},
		deleteUser(data) {
			this.dialog.removeCustomer = true;
			this.fromData = data;
		},
		//  获取子级用户列表
		async getNextUsers(uid, flag) {
			var user = await this.$API.getNextUserInfo({
				userId: uid,
			});

			this.tableData = user.data;
			if (flag) {
				this.getUsers();
			}
		},
		// 关闭弹窗清空里面信息
		closedialog() {
			this.fromData = {
				corpName: '',
				name: '',
				password: '',
				remark: '',
			};
		},
		// 获取用户列表
		async getUsers() {
			let { id, userName, parentId } = this.$store.state.LOGINUSER;
			let infouser = this.tableData.slice(0, this.tableData.length);
			infouser.push({
				userId: 0,
				name: userName,
				parentId: parentId,
			});
			let data = handleTree(infouser, this.$store.state.LOGINUSER.parentId, 'userId', 'parentId', 'children');
			this.treeData = data;
		},
	},
	computed: {
		getUserList() {
			return this.$store.state.userList;
		},
		UserParentId() {
			console.log(process.env.NODE_ENV == 'development');
			if (process.env.NODE_ENV == 'development') {
				return this.$store.state.LOGINUSER.parentId == '322285' ? true : false;
			} else {
				return this.$store.state.LOGINUSER.parentId == '339374' ? true : false;
			}
		},
	},
	created() {
		this.getNextUsers(this.$store.state.LOGINUSER.id, true);
		this.$notify.info({
			title: '提示',
			message: '平台将定时推送您的用卡信息，欢迎留下您的邮箱地址。',
			duration: 5000,
		});
	},
	data() {
		return {
			filterText: '',
			currentPageSize: 100,
			UserTips: {
				user: false,
			},
			fromData: {
				corpName: '', //客户名称
				name: '', // 登录账号
				checkSim: 1, //  权限
				password: '', // 登录密码
				remark: '', //备注
				customCode: '', //客户代码
			},
			treeData: [
				// 用户树形数据
			],
			defaultProps: {
				children: 'children',
				label: 'name',
			},
			tableData: [], // 用户表格数据
			currentPage: 1,
			dialog: {
				addCustomer: false,
				removeCustomer: false,
			},
			statusType: {
				options: [
					{
						value: '选项1',
						label: '全部状态',
					},
					{
						value: '选项2',
						label: '沉默',
					},
					{
						value: '选项3',
						label: '激活',
					},
				],
				value: '选项1',
			},
			emailvisible: false, //邮箱弹框
			emailStatus: 0, //邮箱弹框状态
			email: '',
		};
	},

	components: {
		myTree,
		passWord,
		Email,
	},
};
</script>

<style lang="scss" scoped>
@import '@/public/css/base.scss';
@import '@/public/css/mixin.scss';
.customer {
	display: flex;
	overflow: hidden;
	position: absolute;
	left: 20px;
	right: 20px;
	top: 20px;
	bottom: 20px;
	.customer-left {
		width: 230px;
		padding: 20px;
		margin-right: 20px;
		background: #fff;
		display: flex;
		flex-direction: column;
	}
	.customer-right {
		background: #fff;
		flex: 1;
		min-width: 900px;
		position: relative;
		.filter-type {
			border-bottom: 1px solid #ebf0f6;
			padding: 16px 20px 14px;
			font-size: 14px;
			display: flex;
			flex-wrap: nowrap;

			.filter-btn {
				color: $btnColor;
				border: 1px solid $btnColor;
				white-space: nowrap;
				cursor: pointer;
				padding: 0 15px;
				height: 26px;
				line-height: 26px;
				font-size: 13px;
				margin-left: 10px;
				&:nth-child(1) {
					margin: 0;
				}
			}
			.filter-btn-primary {
				color: #fff;
				background-color: $btnColor;
			}
		}
		.filter-table-wrap {
			border: 1px solid #ebf0f6;
			position: absolute;
			top: 84px;
			left: 20px;
			right: 20px;
			bottom: 20px;
			.cus_box {
				display: flex;
				justify-content: center;
			}
		}
	}
}
/deep/ .el-dialog {
	.input-item {
		.form_warning {
			color: #f56c6c;
			font-size: 12px;
			line-height: 1;
			margin-left: 10px;
		}
	}
	.removeCustomer {
		text-align: center;
		.error-icon {
			text-align: center;
			i {
				font-size: 60px;
				color: #dd5e5e;
				margin: 0 auto;
			}
		}
		.comfir-msg {
			color: #5e6571;
			margin: 20px 0;
			span {
				color: $btnColor;
			}
		}
		.tips-msg {
			margin-bottom: 10px;
			color: #98a4b9;
			font-size: 12px;
			display: block;
			&:last-child {
				margin: 0;
			}
		}
	}
}
.box_span {
	display: inline-block;
	line-height: 46px;
	margin-left: auto;
	color: #d61c1c;
}
/deep/ .remove-dialog {
	.el-dialog .el-dialog__header {
		border: 0;
	}
}
</style>
